import { connect } from "react-redux";
//import CCavenuePayment from "../../components/orders/CCavenuePayment";
import RazorpayPayment from "../../components/orders/RazorpayPayment";
import { bindActionCreators } from "redux";
import { getPrice, generateImage } from "../../actions/orders";

const mapStateToProps = (state, ownProps) => {
  return {
    product_id: ownProps.product_id,
    setno: ownProps.setno,
    pageno: ownProps.pageno,
    no_of_files: ownProps.no_of_files,
    prtype: ownProps.prtype,
    numpages: ownProps.numpages
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getPrice,
      generateImage
    },
    dispatch
  );

const RazorpayPaymentContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(RazorpayPayment);

export default RazorpayPaymentContainer;
